export class EntityBase {
  public id: number;

  static fromJSON(json: any): EntityBase {
    return new this(json);
  }

  static fromJSONArray(json: any[]): EntityBase[] {
    return json.map(inst => this.fromJSON(inst));
  }

  constructor(json: any) {
    if (!json) {
      return this;
    }

    Object.assign(this, json);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/model/EntityBase.ts